import { EntitiesList } from "./common/entitiesList";
import { Avatar, UploadingFileInfo } from "./media";
import { TravelClaimFileInList } from "./travelClaims";

export type ColleaguesTypes = "COLLEAGUE" | "OUTSTAFF";

export type User = {
  pk: string;
  role: string;
  first_name: string;
  middle_name: string;
  last_name: string;
  post: string;
  department: string;
  brand: string;
  phone: string;
  photo_img?: Avatar;
  email: string;
  active_directory_expired: string;
};

export interface UsersListResponse extends EntitiesList {
  results: Array<User>;
}

export type ColleagueInList = {
  pk: string;
  first_name: string;
  middle_name: string;
  last_name: string;
  post: string;
  department: string;
  brand: string;
};

export type ColleagueForSelector = {
  pk: string;
  name: string;
  post?: string | null;
  department?: string | null;
  brand?: string | null;
};

export interface ColleaguesListResponse extends EntitiesList {
  results: ColleagueInList[];
}

export interface ClaimColleaguesListResponse extends EntitiesList {
  results: Colleague[];
}

export type Colleague = {
  id: string;
  pk: string;
  colleague_pk: ColleagueInList;

  type: ColleaguesTypes;

  full_name: string;
  phone: string;

  tickets_need: boolean;
  hotel_need: boolean;
  other_documents_need: boolean;
};

export type ColleagueFull = {
  pk: string;
  claim: number;
  type: string;
  colleague_pk: User;
  full_name: string;
  phone: string;
  tickets_need: boolean;
  hotel_need: boolean;
  other_documents_need: boolean;
  files: Array<TravelClaimFileInList>;
};

export type ColleagueShort = {
  pk: string;
  claim: number;
  type: string;
  colleague_pk: User;
  full_name: string;
  phone: string;
};

// Интерфейс для накопления обновлений в коллегах
export type ColleagueModel = {
  colleague_pk: ColleagueForSelector | null;

  type: ColleaguesTypes | null;

  full_name: string | null;
  phone: string | null;

  tickets_need: boolean;
  hotel_need: boolean;
  other_documents_need: boolean;
  uploadingFiles: UploadingFileInfo[];
  deletingFiles: string[];
};

// Интерфейс для контекста модели обновления
export interface ColleagueUpdateContextType {
  model: ColleagueModel;
  updateModel: (updates: Partial<ColleagueModel>) => void;
  resetModel: () => void;
}

export enum UserRoles {
  // 1 - Пользователь
  // 2 - Тревел-менеджер
  // 3 - Тревел-администратор
  // 4 - Администратор приложения
  // 5 - Супер-администратор
  USER = 1,
  TRAVEL_MANAGER = 2,
  TRAVEL_ADMIN = 3,
  APP_ADMIN = 4,
  SUPER_ADMIN = 5,
}
